"use strict";

import Page from "./Organization.jsx";

export const auth = true;
export const title = "i18n:organization.pageTitle";
export const Component = Page;
